module.exports = __webpack_public_path__ + "static/media/greatwood.d293ce19.jpg";